import { IPaginationData } from 'redhotpie-shared-lib/interfaces/IUtils';
import * as utils from '../functions/utils';
// eslint-disable-next-line
export class PagingInfo {
  isLoading?: boolean;
  page: number;
  isHasMoreData?: boolean;
  total?: number;
  totalPages?: number;
  size: number;
  totalItems: number;
  isHasMore: boolean;

  constructor(Page?: any) {
    this.page = Page && Page.Page ? Page.Page : 1;
    this.size = Page && Page.Size ? Page.Size : 0;
    this.totalItems = Page && Page.TotalItems ? Page.TotalItems : 0;
    this.totalPages = Page && Page.TotalPages ? Page.TotalPages : 0;
    this.isHasMore = Page && Page.IsHasMore ? Page.IsHasMore : (this.totalPages || 0) > (this.page || 0);
  }

  static mappingObject(pageInfo: any): IPaginationData {
    let _pageInfo = Object.assign(new PagingInfo(), pageInfo);
    _pageInfo.page = pageInfo.Page;
    _pageInfo.size = pageInfo.Size;
    _pageInfo.totalItems = pageInfo.TotalItems;
    _pageInfo.totalPages = pageInfo.TotalPages;
    _pageInfo.isHasMore = pageInfo.IsHasMore || pageInfo.TotalPages > pageInfo.Page;
    _pageInfo = utils.cleanObjectKeys(Object.keys(new PagingInfo()), _pageInfo);
    return _pageInfo;
  }
}
